import { z } from 'zod';
import { LanguageCode } from '../enums';

export const ConfigsStepPostSignQaTranslations = z.object({
  language_id: LanguageCode,
  step_post_sign_qa_id: z.string().uuid(),
  sentence: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type ConfigsStepPostSignQaTranslationsT = z.infer<
  typeof ConfigsStepPostSignQaTranslations
>;

export const ConfigsStepPostSignQaTranslationsInsert =
  ConfigsStepPostSignQaTranslations.partial().merge(
    ConfigsStepPostSignQaTranslations.pick({
      language_id: true,
      sentence: true,
      step_post_sign_qa_id: true,
    })
  );

export type ConfigsStepPostSignQaTranslationsInsertT = z.infer<
  typeof ConfigsStepPostSignQaTranslationsInsert
>;

export const ConfigsStepPostSignQaTranslationsUpdate =
  ConfigsStepPostSignQaTranslations.omit({
    created_at: true,
  }).partial();

export type ConfigsStepPostSignQaTranslationsUpdateT = z.infer<
  typeof ConfigsStepPostSignQaTranslationsUpdate
>;
